<form *ngIf="form && processSheets" [formGroup]="form" class="generic-form-fields">
  <dx-lookup formField required formControlName="processSheetId"
             [label]="'entity.maintenancePlans.processSheetId' | translate | ucfirst"
             (created)="createProcessSheet($event)"
             [createComponent]="createProcessSheetComponent"
             [dataSource]="processSheets"
             itemTemplate="template"
             displayExpr="name"
             valueExpr="id"
  >
    <div *dxTemplate="let data of 'template'">
      <div *ngIf="data">
        {{data.code}} | {{data.name}}
      </div>
    </div>
  </dx-lookup>
</form>
